import React from 'react';
import { Helmet } from '../../../modules/foundation/components/HelmetProvider';
var WebsiteSchema = function WebsiteSchema(_ref) {
  var name = _ref.name,
    url = _ref.url,
    description = _ref.description;
  var websiteData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: name,
    url: url,
    description: description
  };
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(websiteData)));
};
export default WebsiteSchema;
WebsiteSchema.defaultProps = {
  url: null,
  description: null
};